import Helpers from 'utils/helpers';
import _ from 'lodash';

export default function softwareUpdateDashboardTransformResults(data) {
  const sitesObj = _.groupBy(data, 'hierarchyId');
  const sitesArr = [];
  for (let siteId in sitesObj) {
    const firstSite = sitesObj[siteId][0];
    const newSite = {
      hierarchyName: firstSite.hierarchyName,
      hierarchyId: firstSite.hierarchyId,
      QMVersion: 'Not Detected',
      SPCVersion: 'Not Detected',
      PAYVersion: 'Not Detected',
      MZAVersion: 'Not Detected',
      MZPVersion: 'Not Detected',
      id: siteId
    };
    for (let site of sitesObj[siteId]) {
      if (site.softwareTypeId === 2 && !Helpers.String.isEmpty(site.installedVersion)) {
        newSite.SPCVersion = site.installedVersion;
      }
      if (site.softwareTypeId === 3 && !Helpers.String.isEmpty(site.installedVersion)) {
        newSite.QMVersion = site.installedVersion;
      }
      if (site.softwareTypeId === 4 && !Helpers.String.isEmpty(site.installedVersion)) {
        newSite.MZPVersion = site.installedVersion;
      }
      if (site.softwareTypeId === 5 && !Helpers.String.isEmpty(site.installedVersion)) {
        newSite.MZAVersion = site.installedVersion;
      }
      if (site.softwareTypeId === 6 && !Helpers.String.isEmpty(site.installedVersion)) {
        newSite.PAYVersion = site.installedVersion;
      }
    }

    sitesArr.push(newSite);
  }
  return sitesArr;
}
